module.exports = __webpack_public_path__ + "img/long-arrow-right.e85bc697.svg";